export default __webpack_public_path__ + "static/media/play_earn.eb29fc7d.png";